<template>
  <v-container>
    <v-dialog v-model="dialog.show" max-width="700px"
              @click:outside="$store.commit('close_confirmation_dialog')">
      <v-card>
        <v-toolbar flat :color="colors[dialog.color].color_text" dark class="justify-center">
          <v-toolbar-title>{{ dialog.title }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="py-5">
          {{ dialog.text_start }}
          <span class="font-weight-bold" :style="'color:'+colors[dialog.color].color+'!important;'">
            {{ dialog.item_to_confirm }}
          </span>
          {{ dialog.text_end }}
        </v-card-text>
        <v-card-actions>
          <v-btn depressed :loading="loading" :color="colors[dialog.color].color_text"
                 @click="confirm">
            بله
          </v-btn>
          <v-spacer/>
          <v-btn depressed outlined :color="colors[dialog.color].color_text"
                 @click="$store.commit('close_confirmation_dialog')">
            خیر
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "ConfirmationDialog",
  data() {
    return {
      loading:false,
      colors: [
        {
          color: '#616161',
          color_text: 'grey'
        },
        {
          color: '#00BFA5',
          color_text: 'teal accent-4'
        },
        {
          color: '#FF5252',
          color_text: 'error'
        },
      ]
    }
  },
  computed: {
    ...mapState({
      dialog: state => state.confirmation_dialog
    })
  },
  methods: {
    confirm() {
      let context = this
      context.loading = true
      // console.log(this.dialog.confirm_action, this.dialog.action_payload)
      this.$store.dispatch(this.dialog.confirm_action, this.dialog.action_payload).then(() => {
        context.$store.dispatch(this.dialog.success_action)
        context.$store.commit('close_confirmation_dialog')
        context.loading = false
      }).catch(() => {
        context.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>